import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from "@ionic/angular";
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {

    data: any = this.navParams.data;
    title;
    desc;
    chat_notification: boolean = false;
    testimony_notification: boolean = false;

    constructor(
        public navParams: NavParams,
        public popover: PopoverController,
        private router: Router,
    ) {
        this.data = navParams.data;
    }

    ngOnInit() {
        console.log("Data of notify", this.navParams)
        // console.log("value of title", this.navParams.data.data.body)
        if (this.navParams.data.data.body && this.navParams.data.data.title) {
            if (this.navParams.data.type == 'conversation') {
                this.title = this.navParams.data.data.title;
                let message = this.navParams.data.data.extra_data.msg_text;
                if (message.length > 50) {
                    message = message.substr(0, 50) + ' ...';
                }
                this.desc = message;
                this.chat_notification = true;
            } else if(this.navParams.data.type=='testimony_received'){
                console.log('Testimony Received!');
                this.testimony_notification = true;
                this.title = this.navParams.data.data.body;
                this.desc = this.navParams.data.data.body;
            }else if (this.navParams.data.type == 'leader_conversation') {
                this.chat_notification = true;
                this.title = this.navParams.data.data.body;
                let message = this.navParams.data.data.message
                if (message.length > 50) {
                    message = message.substr(0, 50) + ' ...';
                }
                this.desc = message;

            } else {
                // this.desc = this.navParams.data.data.message;
                // this.title = this.navParams.data.data.body;
                this.title = this.navParams.data.data.title;
                this.desc = this.navParams.data.data.body;
            }

        } else {
            if (this.navParams.data.data.body) {
                this.title = this.data.body;
            } else {
                if (this.data.extra_data.type === 'message') {
                    this.title = this.data.title;
                    this.desc = this.data.extra_data.msg_body.text;
                } else if (!this.data.desc) {
                    this.desc = this.data.body;
                    this.title = "";
                } else {
                    this.desc = this.data.desc;
                    this.title = this.data.body;
                }

                if (this.data.type == 'conversation') {
                    this.chat_notification = true;
                }
            }
        }


    }

    NavigateToChat() {
        if (this.navParams.data.type == 'leader_conversation') {
            this.router.navigate(['/admin-om-chat-messages', { conversation: this.navParams.data.data.conversation_uuid, name: this.navParams.data.data.name }]);


        } else {
            this.router.navigate(['/seeker-request',
                {
                    conversation: this.data.extra_data.conversation_uuid,
                    channel: this.data.extra_data.channel,
                    seeker_name: this.data.extra_data.seeker_name
                }]);

        }

        this.dismiss();
    }

    NavigateToTestimony() {
        this.router.navigate(['/view-testimony', { s_uuid: this.navParams.data.data.s_uuid }]);
        this.dismiss();
    }

    dismiss() {
        this.popover.dismiss({
            'dismissed': true
        });
    }

}
